import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { applyFilters } from '@wordpress/hooks';
import Header from "../../common/Header";
import ConnectBox from "./ConnectBox";
import './settings-menu.css';

const App = () => {
	/**
	 * Filters the default current menu.
	 *
	 * @since 1.0.0
	 * @param {string} defaultMenu The default menu.
	 */
	const defaultMenu = applyFilters('easycommerce.settings.default.menu', "General");

	const [currentMenu, setCurrentMenu] = useState(defaultMenu);
	const [showAPIModal, setShowAPIModal] = useState(false);
	const [user, setUser] = useState(null);

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const menu = queryParams.get("menu");
		setCurrentMenu(menu || currentMenu);
	}, []);

	useEffect(() => {
		const connectContainer = document.getElementById("easycommerce-connect-box");
		if (connectContainer) {
			const root = createRoot(connectContainer);
			root.render(
				<ConnectBox user={user} setUser={setUser} setShowAPIModal={setShowAPIModal} />
			);
		}
	}, [user]);

	/**
	 * Filters the breadcrumbs.
	 *
	 * @since 1.0.0
	 * @param {Array} breadcrumbs The breadcrumbs array.
	 */
	const breadcrumbs = applyFilters('easycommerce.settings.breadcrumbs', [ "Settings", currentMenu ].map(item => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()));

	return (
		<Header
			breadcump={breadcrumbs}
			showAPIModal={showAPIModal}
			setShowAPIModal={setShowAPIModal}
			user={user}
			setUser={setUser}
		/>
	);
};

const container = document.getElementById("easycommerce-settings-header");
const root = createRoot(container);
root.render(<App />);
